import type { EventId, ThreadId } from "@t3tools/contracts";
import { queryOptions } from "@tanstack/react-query";
import { ensureNativeApi, readNativeApi } from "../nativeApi";
import { useStore } from "../store";

export function activityDetailQueryOptions(threadId: ThreadId, activityId: EventId) {
  return queryOptions({
    queryKey: ["operators", "activity-detail", threadId, activityId] as const,
    queryFn: () => ensureNativeApi().orchestration.getActivityDetail({ threadId, activityId }),
    staleTime: Infinity,
    retry: false,
  });
}

export function threadSummariesQueryOptions(
  threadIds: readonly ThreadId[],
  enabled: boolean,
  scope: "pinned" | "sidebar" = "pinned",
) {
  return queryOptions({
    queryKey: ["operators", "thread-index", scope, ...threadIds] as const,
    queryFn: async ({ signal }) => {
      const api = ensureNativeApi();
      const existingIds = new Set(useStore.getState().threads.map((thread) => thread.id));
      const ids = scope === "sidebar" ? threadIds.filter((id) => !existingIds.has(id)) : threadIds;
      for (let i = 0; i < ids.length; i += 100) {
        const page = await api.orchestration.getThreadIndex({
          threadIds: ids.slice(i, i + 100),
        });
        if (signal.aborted || api !== readNativeApi()) throw new Error("Thread loading cancelled.");
        const state = useStore.getState();
        if (page.revision < state.threadIndexRevision)
          throw new Error("Threads changed while loading.");
        state.syncThreadIndex(page, { updateCursor: false });
      }
      return true;
    },
    enabled: enabled && threadIds.length > 0,
    staleTime: 30_000,
  });
}
